export default (phoneNumber) => {
  let value;

  if (phoneNumber) {
    const matches = phoneNumber.match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

    value = `(${matches[2]}) ${matches[3]}-${matches[4]}`;
  }

  return value;
};



// WEBPACK FOOTER //
// ./app/lib/formatPhoneNumber.js